
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-photography",
      function () {
        return require("private-next-pages/service-photography.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-photography"])
      });
    }
  